import { render } from "./Paginator.vue?vue&type=template&id=06ff9861&scoped=true"
import script from "./Paginator.vue?vue&type=script&lang=js"
export * from "./Paginator.vue?vue&type=script&lang=js"

import "./Paginator.vue?vue&type=style&index=0&id=06ff9861&lang=less&scoped=true"

import exportComponent from "G:\\小程序\\OT ASAR\\vue后台\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ff9861"]])

export default __exports__